import { createSelector } from '@reduxjs/toolkit';
import { selectReportSettings } from '../../store/selectors';

export const selectSecurityExclusions = createSelector(selectReportSettings, (settings) => settings.securityExclusions);
